export default function Light() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_845_2817)">
                <path
                    d="M18.5535 35.3901C18.6187 36.5763 19.5923 37.5 20.7803 37.5H27.1964C28.3914 37.5 29.368 36.5654 29.428 35.3718C29.5968 32.0115 29.9771 27.7079 32.06 25.6724C34.1107 23.6772 35.2562 20.9957 35.25 18.2049C35.25 12.3024 30.2037 7.5 24.0004 7.5C17.7777 7.5 12.8365 12.1364 12.7515 18.0546C12.7274 19.4535 12.9934 20.8432 13.5344 22.1441C14.0754 23.4451 14.8807 24.6317 15.9042 25.6362C17.9864 27.6891 18.3681 32.0187 18.5535 35.3901Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                />
                <path d="M27 38.25C27 39.9069 25.6569 41.25 24 41.25C22.3431 41.25 21 39.9069 21 38.25" stroke="#949494" strokeWidth="2.25" />
                <line x1="18" y1="33.375" x2="30" y2="33.375" stroke="#949494" strokeWidth="2.25" />
                <path d="M9 16.5H6" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" />
                <path d="M39 16.0605H42" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" />
                <path d="M10.0605 11.5605L7.93923 9.43923" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" />
                <path d="M37.9395 11.1211L40.0608 8.99977" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" />
                <path d="M10.0605 21L7.93923 23.1213" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" />
                <path d="M37.9395 20.5605L40.0608 22.6819" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" />
                <path d="M22.5 23.25H26.25V32.25H22.5V23.25Z" stroke="#949494" strokeWidth="1.5" />
                <path
                    d="M26.25 21.75C26.25 20.9216 26.9216 20.25 27.75 20.25C28.5784 20.25 29.25 20.9216 29.25 21.75C29.25 22.5784 28.5784 23.25 27.75 23.25H26.25V21.75Z"
                    stroke="#949494"
                    strokeWidth="1.5"
                />
                <path
                    d="M22.5 21.75C22.5 20.9216 21.8284 20.25 21 20.25C20.1716 20.25 19.5 20.9216 19.5 21.75C19.5 22.5784 20.1716 23.25 21 23.25H22.5V21.75Z"
                    stroke="#949494"
                    strokeWidth="1.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_845_2817">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
